import { useState } from 'react';
import { getLabDefinitionOptions, type LabDefinitionViewModel } from '@generated';
import { AutocompletePicklistSearchField } from '~/shared/forms/controls/base-fields/AutocompletePicklistSearchField';
import { useQueryClient } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';

export function LabDefinitionSearchField({ onChange }: { onChange: (definition: LabDefinitionViewModel) => void }) {
	const queryClient = useQueryClient();
	const [isFetching, setIsFetching] = useState(false);

	return (
		<div className="flex items-end gap-2">
			<AutocompletePicklistSearchField
				label="Search Labs"
				searchType="lab-definition"
				isDisabled={isFetching}
				onChange={async x => {
					if (!x) {
						return;
					}
					setIsFetching(true);
					try {
						onChange(await queryClient.fetchQuery(getLabDefinitionOptions(x.id)));
					} finally {
						setIsFetching(false);
					}
				}}
			/>
			{isFetching && <Loader2 className="size-5 animate-spin" />}
		</div>
	);
}
